import { Organization } from '../../types';

const OPTIONS_MD_ORGANIZATION_ID = '9408db48-b9f0-43d1-a92f-ee74f980c56e';

export const isOptionsMDOrganization = (organizations: Array<Organization>) => {
    return organizations[0]?.id === OPTIONS_MD_ORGANIZATION_ID;
};
